/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { UserState } from '@gea/digital-ui-lib';
import { Store } from '@ngxs/store';
import { AuthRedirectService, AuthService, SemanticPathService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

/**
 * Checks if there is currently logged in user.
 * Use to protect pages dedicated only for logged in users.
 */
@Injectable()
export class CustomAuthGuard {
  protected authService = inject(AuthService);
  protected authRedirectService = inject(AuthRedirectService);
  protected router = inject(Router);
  protected semanticPathService = inject(SemanticPathService);
  protected tokenStore = inject(Store);

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.isUserLoggedIn().pipe(
      withLatestFrom(this.tokenStore.select(UserState.userState)),
      map(([isLoggedIn, idToken]) => {
        if (!isLoggedIn) {
          return this.router.parseUrl(this.semanticPathService.get('login') ?? '');
        }
        return isLoggedIn;
      }),
    );
  }
}
